import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeModule } from 'alyle-ui/core';
import { LyButton } from './button';
import { LyRippleModule } from 'alyle-ui/ripple-minimal';
import { LyShadowService } from 'alyle-ui/shadow';
var LyButtonModule = /** @class */ (function () {
    function LyButtonModule() {
    }
    LyButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, LyRippleModule, ThemeModule],
                    exports: [LyButton],
                    declarations: [LyButton],
                    providers: [LyShadowService],
                },] },
    ];
    /** @nocollapse */
    LyButtonModule.ctorParameters = function () { return []; };
    return LyButtonModule;
}());
export { LyButtonModule };
//# sourceMappingURL=button.module.js.map